<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['Data', 'Associado', 'Detalhes']"
            :showReload="true"
            :showTipFooter="false"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn IsDatetime :status="1" :value="obj.data" />
        <TableColumn IsText :status="1" :value="obj.cooperado" />
        <TableColumn IsText :status="1" :value="obj.detalhes" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import FollowupRepository from '@/shared/http/repositories/associate/followup.js'

export default {
  name: 'MinhasVisitasList',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      FollowupRepository.GetAllMinhasVisitasPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      FollowupRepository.Delete(obj.id)
        .then(this.onResult)
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/minhasVisitas/components/list/minhasVisitasList.vue